document.addEventListener('DOMContentLoaded', function() {
    const wrappers = document.querySelectorAll('.cases__wrapper');
    let counter = 0;
    Array.from(wrappers).forEach(wrapper => {
        if (counter % 2 == 0) {
            const contents = wrapper.querySelectorAll('.cases__content');
            Array.from(contents).forEach(content => {
                content.classList.add('revert');
            });
        }
        counter++;
    });
});

